import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

/**
 * 배송 필터 빈 화면 CTA(오늘출발 보러가기) 클릭 시 로깅.
 * Android `GoodsListViewModel.onClickEmptyToday` 와 동일.
 * SCREEN 은 AnalyticsScreen context 에서 자동 주입.
 */
export const useLogClickTodayDelivery = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(() => {
    logAnalyticsEvent({ name: 'CLICK_TODAY_DELIVERY' });
  }, [logAnalyticsEvent]);
};
